import { Injectable, NgZone } from '@angular/core';
import { Subject, from, of } from 'rxjs';
import { FileUploaderClient } from '../../typescript-angular-client/api/fileList/filesList.service';
import { FileParameter } from '../../typescript-angular-client/api/fileList/filesList.service.model';
import { FileUploadError, FileUploadInfo } from '../models/FileUploadError';
import { concatMap, tap, share, takeLast, switchMap, catchError } from 'rxjs/operators';
import { NewFilesListService } from '../files-list/files-list.service';
import { FileModel } from '../../typescript-angular-client/model/models';

@Injectable({
  providedIn: 'root'
})
export class FmUploaderService {
  public filesUploadQueue: FileUploadInfo[] = [];
  public errors: FileUploadError[] = [];
  public parentfolder: string;
  private completedAllSubject: Subject<FileUploadError[]> = new Subject();
  private onProgressSubject = new Subject();
  private onStartUploadSubject: Subject<number> = new Subject();

  constructor(
    private zone: NgZone,
    private uploadClient: FileUploaderClient,
    private flService: NewFilesListService
  ) { }

  get completedAll$() {
    return this.completedAllSubject.asObservable().pipe(share());
  }

  get onProgress$() {
    return this.onProgressSubject.asObservable().pipe(share());
  }

  get onStart$() {
    return this.onStartUploadSubject.asObservable().pipe(share());
  }

  public upload(dialogType: FileModel.FileTypeEnum, pageSize: number) {
    if (!this.parentfolder || this.filesUploadQueue.length <= 0) {
      return;
    }

    this.onStartUploadSubject.next(this.filesUploadQueue.length);

    from(this.filesUploadQueue).pipe(
      concatMap((item) => this.uploadClient.upload(
        <FileParameter>{ fileName: item.file.name, data: item.file },
        this.parentfolder, dialogType, true, item.keep).
        pipe(
          tap(
            () => this.zone.run(() => this.onProgressSubject.next()),
            (err) => {
              this.zone.run(() => {
                this.errors.push({
                  name: item.file.name,
                  size: item.file.size.toString(),
                  reason: err
                });
                this.onProgressSubject.next();
              });
            }),
          catchError((error) => of(error))
        )),
      takeLast(1),
      switchMap(() => this.flService.loadByPage(this.parentfolder, 1, dialogType, pageSize))
    ).subscribe({
      next: () => this.zone.run(() => {
        this.completedAllSubject.next(Array.of(...this.errors));
        this.clear();
      })
    });
  }

  public clear = (): void => {
    this.parentfolder = null;
    this.filesUploadQueue.length = 0;
    this.errors.length = 0;
  }

  public showErrors = (): void => {
    this.onStartUploadSubject.next(0);
    this.completedAllSubject.next(Array.of(...this.errors));
    this.clear();
  }

}
